import React from "react";
import WebNav from "src/screens/webNav";

// WebNav already handles PDFs, so this is just a wrapper
export default function PDFDocument(params) {
  return <WebNav {...params} />;
}
